import { Link } from "react-router-dom";
import { ArrowLeft, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PreviewBannerProps {
  portalRoute: string;
}

export function PreviewBanner({ portalRoute }: PreviewBannerProps) {
  return (
    <div className="bg-muted/40 border-b border-border/60">
      <div className="container py-3 flex items-center justify-between gap-3 min-w-0">
        <div className="flex items-center gap-2 min-w-0">
          <Eye className="h-4 w-4 text-muted-foreground shrink-0" />
          <div className="min-w-0">
            <p className="text-sm font-medium text-foreground truncate">
              Du förhandsvisar platsen
            </p>
            <p className="text-xs text-muted-foreground truncate">
              Så här ser platsen ut för besökare i Farmly
            </p>
          </div>
        </div>
        <Button variant="ghost" size="sm" className="shrink-0 gap-1.5 text-muted-foreground" asChild>
          <Link to={portalRoute}>
            <ArrowLeft className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">Tillbaka till redigering</span>
            <span className="sm:hidden">Tillbaka</span>
          </Link>
        </Button>
      </div>
    </div>
  );
}
